import Vue from 'vue'
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import * as mutations from './mutations'
import * as actions from './actions'

import login from './modules/login'
import structs from './modules/structs'
import covid from './modules/covid'
import order from './modules/order'
import interview from './modules/interview'

Vue.use(Vuex);

const state = {
    processing: false,
    checked: false,
    firstVictimCheck: false,
    userData: null,
    greeting: null,
    linkOrder: null,
    defaultParams: {},
}

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        login,
        structs,
        covid,
        order,
        interview
    },
    plugins: [
        createPersistedState({ 
            key: 'covid', 
            storage: window.localStorage 
        })
    ]
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js